const theme = {
  color: {
    primary: "#C3FF94",
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default theme;
